<input
  #inputRef
  type="text"
  matInput
  ssFormInput
  [matAutocomplete]="autoCompleteRef"
  [value]="displayObs | async"
/>

<mat-autocomplete
  autoActiveFirstOption
  #autoCompleteRef
  [displayWith]="displayWithObs | async"
  (optionSelected)="handleOptSelected($event)"
>
  <ng-container *ngIf="(listItemsSubject | async)?.length">
    <mat-option
      *ngFor="let item of listItemsSubject | async"
      [value]="item.value"
      >{{ item.text }}</mat-option
    >
  </ng-container>

  <ng-container *ngIf="dataSourceSubject | async">
    <mat-option
      *ngFor="let item of locallyFilteredDataSubject | async"
      [value]="item"
    >
      <ng-container *ngIf="matOptionTemplateRefSubject | async">
        <ng-container
          *ngTemplateOutlet="
            matOptionTemplateRefSubject | async;
            context: { item: item }
          "
        ></ng-container>
      </ng-container>

      <p *ngIf="!(templateSubject | async)">
        {{ (displayWithObs | async)(item) }}
      </p>
    </mat-option>
  </ng-container>
</mat-autocomplete>
